// import './sentry';
import 'invokers-polyfill';
import Panzoom from '@panzoom/panzoom';
// Uncomment to enhance details/summary elements
// const accordions = Array.from(document.querySelectorAll('details'));
// accordions.forEach(accordion => {
// 	new Accordion(accordion);
// });
const initFuse = async () => {
	const list = document.querySelector('[data-filterable]');
	if (!list) {
		return;
	}

	const { default: Fuse } = await import('fuse.js');
	const items = Array.from(
		list.querySelectorAll('li:has(.person-teaser)'),
	) as HTMLElement[];
	const fuse = new Fuse(
		items.map(item =>
			[
				item.querySelector('header')?.innerText,
				item.querySelector('p')?.innerText,
			].join(' '),
		),
		{
			ignoreDiacritics: true,
			threshold: 0.3,
			includeScore: true,
			ignoreLocation: true,
		},
	);

	input?.addEventListener('input', () => {
		if (!input.value) {
			items.forEach(item => {
				item.hidden = false;
				item.removeAttribute('data-score');
			});
			items.forEach(el => list.appendChild(el));
			return;
		}
		const result = fuse.search(input.value);
		items.forEach((item, idx) => {
			item.hidden = !result.map(hit => hit.refIndex).includes(idx);
			const score = result.find(hit => hit.refIndex === idx)?.score;
			if (score) {
				item.dataset.score = score;
			} else {
				item.removeAttribute('data-score');
			}
		});

		items
			.toSorted(
				(a, b) => parseFloat(b.dataset.score) - parseFloat(a.dataset.score),
			)
			.forEach(el => list.appendChild(el));
	});
};

const input = document.getElementById('query');
if (input) {
	initFuse();
}

const toggleButtons = Array.from(
	document.querySelectorAll('button[aria-controls]'),
);

function checkOverflow(el: HTMLElement) {
	return el.scrollHeight > el.clientHeight;
}
toggleButtons.forEach(button => {
	const target = document.getElementById(button.getAttribute('aria-controls'));
	button.hidden = !checkOverflow(target);
	button.addEventListener('click', () => {
		const pressed = button.getAttribute('aria-pressed') === 'true';
		button.setAttribute('aria-pressed', pressed ? 'false' : 'true');
		button.innerHTML = pressed ? '&plus;' : '&minus;';
	});
});

const currentPage = document.querySelector(
	".pages [aria-current='page']",
) as HTMLAnchorElement;
if (currentPage) {
	const p = currentPage.closest('.pages');
	if (p) {
		const left =
			currentPage.getBoundingClientRect().left -
			p.getBoundingClientRect().left +
			p.scrollLeft;
		p.scrollLeft = left - (p.clientWidth - currentPage.offsetWidth) / 2;
	}
}

const scan = document.querySelector('.scan img') as HTMLElement;
if (scan) {
	const panzoom = Panzoom(scan, {
		maxScale: 3,
		contain: 'outside',
		cursor: 'zoom-in',
	});
	scan.addEventListener('click', () => {
		panzoom.zoom(2, { animate: true });
	});
	scan.parentElement?.addEventListener('wheel', panzoom.zoomWithWheel);
	scan.addEventListener('panzoomchange', () => {
		panzoom.setOptions({
			cursor: panzoom.getScale() == 2 ? 'move' : 'zoom-in',
		});
	});
}

// Trigger HMR
if (import.meta.hot) {
	// HMR code
}
